/**
 * The ads cookie banner (POPIA). Shown only while an ad id is configured and the visitor has not
 * answered — or reopened it from the footer's "Cookie settings". Accept and Decline carry equal
 * weight; nothing marketing loads before Accept (ads.ts).
 */
import { useEffect, useState } from "react";
import { bannerVisible, CONSENT_OPEN_EVENT, readAdsConsent, setAdsConsent, type AdsConfig, type AdsConsent } from "./ads";

export function ConsentBanner({ ads }: { ads: AdsConfig | null | undefined }) {
  const [consent, setConsent] = useState<AdsConsent | null>(() => readAdsConsent());
  const [reopened, setReopened] = useState(false);

  useEffect(() => {
    const open = () => setReopened(true);
    window.addEventListener(CONSENT_OPEN_EVENT, open);
    return () => window.removeEventListener(CONSENT_OPEN_EVENT, open);
  }, []);

  if (!bannerVisible(ads, consent, reopened)) return null;
  const choose = (v: AdsConsent) => {
    setAdsConsent(v);
    setConsent(v);
    setReopened(false);
  };
  return (
    <section className="ads-consent" role="region" aria-label="Cookie choice">
      <p>
        We use cookies to measure our ads.{" "}
        {consent && <span className="ads-consent-now">You currently {consent === "granted" ? "allow" : "decline"} them. </span>}
        You can change this any time under “Cookie settings” at the bottom of the page.
      </p>
      <div className="ads-consent-btns">
        <button type="button" className="btn" onClick={() => choose("granted")}>Accept</button>
        <button type="button" className="btn" onClick={() => choose("denied")}>Decline</button>
      </div>
    </section>
  );
}
